import { brandColours } from '@birdi/theme'
import { parse, v5 } from 'uuid';

const colours = [
  brandColours.crimsonSunbird,
  brandColours.canary,
  brandColours.sunConure,
  brandColours.ocean,
  brandColours.flora,
  // brandColours.midnight,
];

/** Pick a colour based on a given UUID.
 * Chosen colour will be stable, unless additional colours are added,
 * in which case they will change slightly but then continue to be stable afterwards. */
export const getUserColour = (uuid: string) => {
  // Not trying to get a real numeric representation of a UUID here, just doing
  // the bare minimum to go from string to a number so we can perform math on it.
  if (!uuid) {
    uuid = v5('unknown', '84a60369-3e2b-46a3-a5e1-72cf8a839c6b');
  }
  const number = [...parse(uuid)].reduce((a, b) => a + b, 0);
  return colours[number % colours.length];
};
